export class Tags {
  public label: string;
  public value: number;
  public color: string;
  public textColor: string;
  public notUsed: boolean;
  public cocherAjouterDroitAccesGroupeID: number;
  public courrierActionDroitCocherGroupeID: number;
  public courrierActionDroitDecocherGroupeID: number;
  public ordreAffichage: number;
  public servicesAuthorized: Array<number>;
  public isNewlyCreated?: boolean;

  constructor(data: Partial<Tags>) {
    Object.assign(this, data);
  }
}

export class TagDeletion {
  id: number;
  isDeleted: boolean;
  errorCode: number;
}
